import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { commaFormatNumber } from '@Utils/String';
import { recordCountOrResultSizeFromRelativeContextItem } from '@Containers/PatentFamilyClustering/selectors';
import Button from '@Components/Button';
import { mapContextToTitle } from '../ResultToolbarConstants';

export default function AvailableRelativeContextButton(props) {
  const { item, goToResultPage } = props;
  const context = item.get('context');
  const recordCountOrResultSize = recordCountOrResultSizeFromRelativeContextItem(item);
  const contextTitle = mapContextToTitle[context];

  if (!recordCountOrResultSize) {
    return <span>{`0 ${contextTitle}`}</span>;
  }

  return (
    <Button
      onClick={() => {
        goToResultPage({
          resultName: item.get('resultName'),
          databaseId: item.get('databaseId'),
          context: item.get('context'),
          hitSetKey: item.get('hitSetKey'),
          resultSize: item.get('resultSize'),
          recordCount: item.get('recordCount'),
        });
      }}
      buttonConfig={{
        label: `${commaFormatNumber(recordCountOrResultSize)} ${contextTitle}`,
        type: 'link',
        size: 'xs',
        color: 'blue',
        e2eName: `context-switcher-${context}`,
      }}
    />
  );
}

AvailableRelativeContextButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  goToResultPage: PropTypes.func.isRequired,
};
